/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Gpweightedorder3Inputs */

const en_coinvestments_tracking_gpweightedorder3 = /** @type {(inputs: Coinvestments_Tracking_Gpweightedorder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wtd. Order`)
};

/**
* | output |
* | --- |
* | "Wtd. Order" |
*
* @param {Coinvestments_Tracking_Gpweightedorder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_gpweightedorder3 = /** @type {((inputs?: Coinvestments_Tracking_Gpweightedorder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Gpweightedorder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_gpweightedorder3(inputs)
});
export { coinvestments_tracking_gpweightedorder3 as "coInvestments_tracking_gpWeightedOrder" }